const DoubleTap = {
    mounted() {
        this.tapCount = 0;
        this.tapTimer = null;
        this.tapDelay = 200;

        this.el.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.tapCount++;

            if (this.tapCount === 1) {
                this.tapTimer = setTimeout(() => {
                    this.tapCount = 0;

                    const honorific = this.el.dataset.honorific;
                    const kink = this.el.dataset.kink;
                    const preferredLabel = this.el.dataset.preferred_label;

                    if (honorific) {
                        this.pushEventTo(this.el.closest("form"), "toggle_honorific", { honorific: honorific });
                    } else if (kink) {
                        this.pushEventTo(this.el.closest("form"), "toggle_kink", { kink: kink });
                    } else if (preferredLabel) {
                        this.pushEventTo(this.el.closest("form"), "toggle_preferred_label", {
                            preferred_label: preferredLabel,
                        });
                    }
                }, this.tapDelay);
            } else if (this.tapCount === 2) {
                clearTimeout(this.tapTimer);
                this.tapCount = 0;

                const honorific = this.el.dataset.honorific;
                const kink = this.el.dataset.kink;
                const preferredLabel = this.el.dataset.preferred_label;

                if (honorific) {
                    this.pushEventTo(this.el.closest("form"), "favorite_honorific", { honorific: honorific });
                } else if (kink) {
                    this.pushEventTo(this.el.closest("form"), "favorite_kink", { kink: kink });
                } else if (preferredLabel) {
                    this.pushEventTo(this.el.closest("form"), "favorite_preferred_label", {
                        preferred_label: preferredLabel,
                    });
                }
            }
        });
    },
};

export default DoubleTap;
